import Header from "../component/header";
import Footer from "../component/footer";
import Lenis from 'lenis'
import useGsapAnimations from '../component/useGsapAnimations';


function Service() {
    useGsapAnimations()
    
    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)
    
    return (
<main>
   <Header/>


    <div id="smooth-wrapper">
        <div id="smooth-content">
            {/* <!-- Add your site or application content here --> */}
            <main>

                {/* <!-- service banner area start  --> */}
                <div className="service-banner-area section-spacing fix p-relative adjust-header-space">
              <div className="hero-area__bg">
 <video width="320" height="240" playsinline="" crossorigin="anonymous" data-cursor-text="" data-cursor="-exclusion" muted="true" autoplay="true" loop="true" className="css--1un3bny">
                            <source src="assets/video/6916632_Motion_Graphics_Motion_Graphic_1280x720.mp4"/>
                        </video>
                    </div>
                    
                    <div className="service-banner-shapes">
                       
                        <img className="shape-1" src="assets/img/shapes/star-bordered-3.png" alt="mystra-service"/>
                        <img className="shape-2" src="assets/img/shapes/circle-line.png" alt="mystra-service"/>
                    </div>
                    
                    <div className="container">
                        <div className="service-banner-main p-relative">
                            <div className="row">
                                <div className="col-xxl-9 col-xl-9">
                                    <div className="service-banner-title-box animation__char_come">
                                        {/* <span className="service-banner-subtitle">Our Services</span> */}
                                        <h1>
                                            <span className="service-banner-title">Revolutionizing</span>
                                            <span className="thumb-layout">
                                                <span className="service-banner-title">Your</span>
                                                <span className="thumb-1 bdFadeLeft"></span>
                                            </span>
                                            <span className="thumb-layout">
                                                <span className="service-banner-title">Digital </span>
                                                <span className="thumb-2 bdFadeLeft"></span>
                                            </span>
                                            <span className="service-banner-title">Experience</span>
                                        </h1>
                                    </div>
                                </div>
                                <div className="hero__shapes d-none d-md-block">
                        <img className="hero__shape-1" src="assets/img/shapes/star-1.png" alt="mystra-service"/>
                        <img className="hero__shape-2" src="assets/img/shapes/star-2.png" alt="mystra-service"/>
                    </div>
                                <div className="col-xxl-3 col-xl-3">
                                    <div className="service-banner-award">
                                        <img src="assets/img/shapes/star-2.png" alt="mystra-service"/>
                                        
                                        {/* <span className="award-bg"></span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*  */}
                {/* <!-- service banner area end  -->

                <!-- service list area start --> */}


                   {/* <!-- team area start  --> */}
    <section className="team-area section-spacing p-relative"> 
        <div className="team-area__overlay" data-background="assets/img/bg/box-gradient-bg.jpg"></div>
        <div className="container">
            <div className="row align-items-end g-5 section-title-spacing">
                <div className="col-lg-6">
                    <div className="section__title-wrapper">
                        
                        <h2 className="section__title-main xlarge uppercase title-anim">
                            Delivering real
                            value for our
                            partners
                        </h2>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="team__meta-description mb-10">
                         <h3 className="section__title-main xlarge uppercase title-anim">Experience design, growth & Tech</h3>
                        <p className='p-text'>
                                                We specialize in human-centric customer experiences, from digital product innovation to transformative business models.
                                                We deliver real value working
                                                closely with our clients to achieve
                                                swift and impactful results
                                                through design innovation and
                                                technology. From start-ups to the
                                                world's leading brands, we work
                                                with companies of all shapes and
                                                sizes.</p>
                    </div>
                </div>
            </div>
        </div>
 
    </section> 

            <section
                    className="page-title-area d-flex align-items-end section-spacing-top p-relative primary-bg adjust-header-space top-services-section service-section">
                    <div className="page-title-shapes">
                        <img className="shape-1 " src="assets/img/shapes/round-circle-2.png" alt="mystra-service"/>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">
                                <div className="page-title-wrappper is-white mb-50">
                                    {/* <div className="breadcrumb-menu mb-20">
                                        <nav aria-label="Breadcrumbs" className="breadcrumb-trail breadcrumbs">
                                            <ul className="trail-items">
                                                <li className="trail-item trail-begin"><span>Our Services</span></li>
                                                <li className="trail-item"><span>UX/UI Design Agency</span></li>
                                            </ul>
                                        </nav>
                                    </div> */}
                                    <div className="section__subtitle-3"><p className="section__subtitle-text">UX/UI Design Agency</p></div>
                                    <h2 className="section__title-inner title-anim">We focus on <span className="tpl__theme-color">usability, accessibility</span> and conversion</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-xxl-6 col-xl-6 col-lg-6">
                                <div className="page-title-thumb">
                                    <img src="assets/img/690-728/Design.webp" alt="mystra-service"/>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 order-first order-lg-last">
                                <div className="service-page-title-contenet">
                                    <h3 className="p-text">we blend creativity with strategy to deliver user experiences that drive results.</h3>
                                    <p className="p-text">We craft seamless digital experiences that connect users to your brand through intuitive interfaces and human-centered design. Our mission is to bridge the gap between functionality and aesthetic, ensuring that every click, swipe, and scroll is meaningful.</p>
                                </div>

                                <div className="row g-5 bdFadeUp mt-30">
          <div className="col-lg-6">
                                            <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                   <span className="process__number">01</span>  User Experience (UX) Design
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">02</span>  User Interface (UI) Design
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">04</span>  UX Strategy & Consulting
                                                </h2>
                                            </div>


                                           
                                        </div>

                                            <div className="col-lg-6">
                                                  <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">03</span>  Web & Mobile App Design
                                                </h2>
                                            </div>
                                           
                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                      <span className="process__number">05</span>  Design-to-Development Handoff
                                                </h2>
                                            </div>

                                           
                                        </div>
                                </div>

                           
                            </div>
                        </div>
                    </div>
                </section>


                 <section
                    className="page-title-area d-flex align-items-end section-spacing-top p-relative primary-bg adjust-header-space bottom-service service-section">
                    <div className="page-title-shapes">
                        <img className="shape-1 " src="assets/img/shapes/round-circle-2.png" alt="mystra-service"/>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">
                                <div className="page-title-wrappper is-white mb-50">
                                    {/* <div className="breadcrumb-menu mb-20">
                                        <nav aria-label="Breadcrumbs" className="breadcrumb-trail breadcrumbs">
                                            <ul className="trail-items">
                                                <li className="trail-item trail-begin"><span>Our Services</span></li>
                                                <li className="trail-item"><span>App Development</span></li>
                                            </ul>
                                        </nav>
                                    </div> */}
                                     <div className="section__subtitle-3"><p className="section__subtitle-text">App Development</p></div>
                                    <h2 className="section__title-inner title-anim">We handle every <span className="tpl__theme-color">phase of the product journey</span> with a focus on <span className="tpl__theme-color">performance, usability</span> and <span className="tpl__theme-color">innovation.</span></h2>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-xxl-6 col-xl-6 col-lg-6">
                                <div className="page-title-thumb">
                                    <img src="assets/img/690-728/Tech-Consulting.webp" alt="mystra-service"/>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 order-first order-lg-last">
                                <div className="service-page-title-contenet">
                                    <h3 className="p-text">you're a startup looking to launch an MVP or an enterprise ready to digitize operations, we deliver custom solutions that meet your business goals and exceed user expectations.</h3>
                                    <p className="p-text">We build powerful, scalable, and user-friendly mobile and web applications that turn your ideas into impact. From concept to code to launch, we handle every phase of the product journey with a focus on performance, usability, and innovation.</p>
                                </div>

                                <div className="row g-5 bdFadeUp mt-30">
          <div className="col-lg-6">
                                            <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                   <span className="process__number">01</span>  Mobile App Development
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">02</span>  Web App Development
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">03</span>  Backend Development
                                                </h2>
                                            </div>
                                        </div>

                                            <div className="col-lg-6">
                                            <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">04</span>  SEO
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                      <span className="process__number">05</span> QA Testing & Optimization
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                      <span className="process__number">06</span> App Launch & Growth Support
                                                </h2>
                                            </div>
                                        </div>
                                </div>

                           
                            </div>
                        </div>
                    </div>
                </section>


<section className="page-title-area d-flex align-items-end section-spacing-top p-relative primary-bg adjust-header-space bottom-service service-section  bottom-curve">
                    <div className="page-title-shapes">
                        <img className="shape-1 " src="assets/img/shapes/round-circle-2.png" alt="mystra-service"/>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">
                                <div className="page-title-wrappper is-white mb-50">
                                    {/* <div className="breadcrumb-menu mb-20">
                                        <nav aria-label="Breadcrumbs" className="breadcrumb-trail breadcrumbs">
                                            <ul className="trail-items">
                                                <li className="trail-item trail-begin"><span>Our Services</span></li>
                                                <li className="trail-item"><span>Social Media Management</span></li>
                                            </ul>
                                        </nav>
                                    </div> */}
                                    <div className="section__subtitle-3"><p className="section__subtitle-text">Social Media Management</p></div>
                                    <h2 className="section__title-inner title-anim"> Creativity with strategy to craft <span className="tpl__theme-color">scroll-stopping content, build loyal communities</span> and keep your brand top-of-mind in the <span className="tpl__theme-color">digital space.</span></h2>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-xxl-6 col-xl-6 col-lg-6">
                                <div className="page-title-thumb">
                                    <img src="assets/img/690-728/Marketing.webp" alt="mystra-service"/>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 order-first order-lg-last">
                                <div className="service-page-title-contenet">
                                    <h3 className="p-text">You're a growing business or an established brand, we help you stay relevant, consistent, and ahead of the competition.</h3>
                                    <p className="p-text">We turn platforms into powerful tools for brand growth, engagement, and revenue. Our team blends creativity with strategy to craft scroll-stopping content, build loyal communities, and keep your brand top-of-mind in the digital space.</p>
                                </div>

                                <div className="row g-5 bdFadeUp mt-30">
          <div className="col-lg-6">
                                            <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                   <span className="process__number">01</span>  Social Media Strategy & Planning
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">02</span>  Content Creation & Copywriting
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">03</span>  Account Management
                                                </h2>
                                            </div>
                                        </div>

                                            <div className="col-lg-6">
                                            <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                     <span className="process__number">04</span>   Analytics & Performance Reporting
                                                </h2>
                                            </div>

                                             <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                      <span className="process__number">05</span>Paid Social Advertising
                                                </h2>
                                            </div>

                                             {/* <div className="accordion-item mt-30">
                                                <h2 className="accordion-header font-smaLL padding-0">
                                                      <span className="process__number">06</span> App Launch & Growth Support
                                                </h2>
                                            </div> */}
                                        </div>
                                </div>

                           
                            </div>
                        </div>
                    </div>
                </section>

 

                <div className="service-list-area section-spacing">
                    <div className="container">
                        <div className="service-list-wrapper">
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">Web Development Services</h3>
                                </div>
                                <div className="service-list-description">
                                    <p>Our team of experts designs and develops stunning websites that captivate and convert. From e-commerce platforms to custom web applications, we bring your vision to life.
                                        We craft intuitive and user-friendly interfaces that enhance user experience and drive engagement.
                                        Our websites are optimized for all devices, ensuring a seamless user experience across desktops, tablets, and mobile phones.</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">Digital Marketing Services</h3>
                                </div>
                                <div className="service-list-description">
                                    <p>Our team of SEO experts optimizes your website to rank higher in search engines, driving organic traffic and increasing visibility.
                                        We create targeted ad campaigns that drive conversions and maximize ROI.</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">AI-Powered Automation Services</h3>
                                </div>
                                <div className="service-list-description">
                                    <p>Our AI agent/chatbot, Ally, automates repetitive but high-accuracy process requirements, freeing up your team to focus on high-value tasks. Ally can:

                                        Vet enquiries and convert cold leads to hot leads
                                        Handle HR-related queries and provide personalized support
                                        Automate pre-sales activities and enhance customer engagement</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">Benefits of Our Services</h3>
                                </div>
                                <div className="service-list-description">
                                    <p>Our SEO-friendly websites and digital marketing strategies drive organic traffic and increase visibility.
                                        Our UI/UX designs and responsive web development ensure a seamless user experience across devices.
                                        Our AI-powered automation services streamline processes, reducing manual errors and increasing productivity.
                                        Our future-proof websites and scalable solutions ensure your business can grow and adapt to changing market conditions.</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">Why Choose Mystra Technologies LLP</h3>
                                </div>
                                <div className="service-list-description">
                                    <p> Our team has a combined industry experience of over 40 years, ensuring you receive the best guidance and support.
                                        We're committed to staying ahead of the curve, leveraging the latest technologies to drive business growth.
                                         We prioritize your success, tailoring our services to meet your unique needs and goals.</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                            <div className="service-list-item bdFadeUp">
                                <div className="service-list-title-inner">
                                    <h3 className="service-list-title">Unlock Your Business Potential</h3>
                                </div>
                                <div className="service-list-description">
                                    <p>Partner with Mystra Technologies LLP to transform your digital presence and drive business growth. Our team of experts is ready to help you achieve your goals. Let's get started!</p>
                                </div>
                                <div className="service-list-link">
                                    <a href="/mystra-contact" className="service-list-btn"><span className="btn-icon"><i
                                                className="flaticon-next"></i></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- service list area end -->

                <!-- step area start --> */}
                <section className="step-area is-grey-bg section-spacing">
                    <div className="container">
                        <div className="section__title-wrapper tpl__item-center mb-60">
                            <h2 className="section__title-inner title-anim">Our Proven Process for Digital Transformation</h2>
                        </div>
                        <div className="step-main-wrapper">
                            <div className="row counter-row g-5">
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Understanding Your Vision</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>We begin by understanding your business goals, challenges, and audience to craft a strategy that aligns with your needs. This step lays the foundation for a custom solution that drives real impact.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Crafting a Roadmap for Success</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>Using insights from the discovery phase, we develop a detailed plan, setting clear milestones, deliverables, and timelines to ensure seamless execution. This roadmap is tailored to your business needs for optimal results.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Bringing Ideas to Life</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>Our team creates interactive prototypes to visualize your product, allowing you to explore its functionality, design, and user experience. This step ensures that we are on the right track before development begins.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Ensuring Quality and Performance</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>We conduct rigorous testing to guarantee that your digital solution is bug-free, optimized for speed, and responsive across all platforms. User acceptance testing (UAT) ensures your product meets real-world expectations.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Launching with Precision</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>Upon successful testing, we deploy your digital solution with meticulous attention to detail, ensuring it’s launched smoothly and performs optimally. We handle all aspects of the launch, from deployment to post-launch monitoring.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Continuous Optimization and Maintenance</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>Post-launch, Mystra provides ongoing support to ensure your digital solution remains updated and functional. We offer regular updates, troubleshooting, and performance monitoring to keep your systems running seamlessly.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Growing Your Digital Presence</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>As your business evolves, so do your needs. Mystra helps scale your digital solution, optimizing it to handle increased traffic, transactions, and complexity, ensuring long-term sustainability and growth.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 bdFadeUp">
                                    <div className="step-item">
                                        <div className="step-content">
                                            <div className="step-content-heading">
                                                <h4 className="step-title">Measuring Success and Driving Improvement</h4>
                                                <div className="num__count"></div>
                                            </div>
                                            <p>We use data-driven insights and analytics to measure your digital solution’s performance. This helps refine strategies, optimize ROI, and continue enhancing the user experience for ongoing business success.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- step area end -->

                <!-- title intro area --> */}
                <section className="title-intro-area fix primary-bg">
                    <div className="container">
                        <div className="title-intro-wrapper section-spacing">
                            <div className="intro__title-wrapper">
                                <h2 className="intro__title-inner folks-text">Let’s talk.</h2>
                            </div>
                            <div className="intro-brn">
                                <a href="/mystra-contact" className="circle-btn is-green">
                                    <span className="icon-box"><i className="flaticon-next"></i></span>
                                    <img src="assets/img/icons/contact-btn-text.png" alt="mystra-service"
                                        className="image-text"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- title intro end --> */}

            </main>
                <Footer/>
         </div>
       </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
  </main>
)}

export default Service;
    